import { NgTemplateOutlet } from '@angular/common';
import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ContentChildren,
	ElementRef,
	Input,
	QueryList,
} from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ValidationErrorDirective } from './validation-error.directive';

interface GroupValidationDisplayComponentDisplayError {
	display: ValidationErrorDirective;
	error: any;
}

@Component({
	selector: 'ae-group-validation-inline-display',
	templateUrl: './group-validation-inline-display.component.html',
	styleUrls: ['./group-validation-inline-display.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgbPopover, NgTemplateOutlet],
})
export class GroupValidationInlineDisplayComponent {
	@Input() maxDisplay: number = 10;

	@ContentChildren(ValidationErrorDirective, { descendants: false })
	private _validationErrors: QueryList<ValidationErrorDirective>;

	public validationErrors: GroupValidationDisplayComponentDisplayError[];

	constructor(
		private cdr: ChangeDetectorRef,
		public hostElement: ElementRef<HTMLElement>,
	) {}

	public displayError = (errors: ValidationErrors) => {
		this.validationErrors = this._validationErrors
			.toArray()
			.map((x) => {
				return {
					display: x,
					error: errors[x.error],
				} as GroupValidationDisplayComponentDisplayError;
			})
			.filter((x) => {
				return x.error != null;
			})
			.slice(0, this.maxDisplay);

		this.cdr.detectChanges();
	};
}
